// @ts-nocheck
import React, { useEffect, useRef } from 'react';
import { Part, Material, Finish } from '../../types';

interface MaterialConfigProps {
  part: Part;
  materials: Material[];
  finishes: Finish[];
  onPartUpdate: (partId: string, field: string, value: string) => void;
  getUniqueMaterialTypes: () => string[];
  getMaterialGrades: (type: string) => string[];
  getMaterialThicknesses: (type: string, grade: string) => string[];
  getUniqueFinishes: () => string[];
}

const MaterialConfig: React.FC<MaterialConfigProps> = ({
  part,
  materials,
  finishes,
  onPartUpdate,
  getUniqueMaterialTypes,
  getMaterialGrades,
  getMaterialThicknesses,
  getUniqueFinishes
}) => {
  const materialTypeRef = useRef<string>('');
  const materialGradeRef = useRef<string>('');
  const materialThicknessRef = useRef<string>('');
  const finishRef = useRef<string>('');

  // Auto-select defaults when component mounts and part has no material selections
  useEffect(() => {
    if (materials.length > 0 && !part.material_type) {
      // Auto-select Aluminum
      onPartUpdate(part.id, 'material_type', 'Aluminum');
    }
  }, [materials, part.material_type, part.id, onPartUpdate]);

  // Ensure defaults are set for any missing values
  useEffect(() => {
    const updates: any = {};
    if (!part.material_type) updates.material_type = 'Aluminum';
    if (!part.material_grade) updates.material_grade = '5052-H32';
    if (!part.material_thickness) updates.material_thickness = '0.125';
    if (!part.finish) updates.finish = 'No Deburring';

    if (Object.keys(updates).length > 0) {
      // Send updates for missing defaults
      Object.entries(updates).forEach(([key, value]) => {
        onPartUpdate(part.id, key, value);
      });
    }
  }, [part.material_type, part.material_grade, part.material_thickness, part.finish, part.id, onPartUpdate]);
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Material</label>
        <select
          key={`material_type_${part.id}_${part.material_type}`}
          value={part.material_type || 'Aluminum'}
          onChange={(e) => onPartUpdate(part.id, 'material_type', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 bg-white"
        >
          {getUniqueMaterialTypes().map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Grade</label>
        <select
          key={`material_grade_${part.id}_${part.material_grade}`}
          value={part.material_grade || ''}
          onChange={(e) => onPartUpdate(part.id, 'material_grade', e.target.value)}
          disabled={!part.material_type}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          {getMaterialGrades(part.material_type).map(grade => (
            <option key={grade} value={grade}>{grade}</option>
          ))}
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Thickness</label>
        <select
          key={`material_thickness_${part.id}_${part.material_thickness}`}
          value={part.material_thickness || ''}
          onChange={(e) => onPartUpdate(part.id, 'material_thickness', e.target.value)}
          disabled={!part.material_type || !part.material_grade}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 bg-white disabled:bg-gray-100 disabled:cursor-not-allowed"
        >
          {getMaterialThicknesses(part.material_type, part.material_grade).map(thickness => (
            <option key={thickness} value={thickness}>{thickness}"</option>
          ))}
        </select>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Finish</label>
        <select
          key={`finish_${part.id}_${part.finish}`}
          value={part.finish || ''}
          onChange={(e) => onPartUpdate(part.id, 'finish', e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200 bg-white"
        >
          {getUniqueFinishes().map(finish => (
            <option key={finish} value={finish}>{finish}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default MaterialConfig;
